define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.format = void 0;
    exports.format = function (baseString, params) {
        for (var i = 0; i < params.length; i++) {
            baseString = baseString.replace("{" + i + "}", params[i]);
        }
        return baseString;
    };
});
